<template>
  <div class="store-page store-page-main margin-xl-top margin-xl-bottom">
    <div class="container container-xl text-center">
      <div class="text-center max-width-400 margin-auto-inline">
        <ag-title
          theme="alt-2"
          class="margin-s-bottom l:margin-l-bottom margin-auto-inline inline-block"
          level="2"
          text="ag.store.mainTitle"></ag-title>
      </div>
      <div class="text-center max-width-800 margin-auto-inline">
        <p
          class="margin-inline-auto margin-remove-top text-gray-4"
          style="line-height: 1.66">
          {{ tu("ag.store.mainText") }}
        </p>
      </div>

      <div class="products margin-2xl-vertical">
        <div
          v-if="asyncStatus.asyncDataLoading"
          class="loading-container padding-xl flex flex-middle width-expand"
          style="min-height: 200px">
          <spinner :size="5" />
        </div>
        <div
          v-if="products"
          class="products-container flex gap-xl flex-center flex-wrap flex-column flex-middle l:flex-stretch l:flex-row">
          <div v-for="product in products" class="product-intro flex-column cursor-pointer" @click="$router.push({name: 'store-productId', params: {productId: product.id}})">
            <div class="product-image-container flex-center width-expand">
              <img class="product-image" :src="product.introImage" alt="" />
            </div>
            <div class="text-content width-expand margin-m-top block text-start">
              <h3 class="margin-remove c-bg-1 text-inline-start">{{ product.name }}</h3>
              <span class="text-2xl c-alt text-start">{{
                translateNumber(product.price, "currency")
              }}</span>
            </div>
            <div class="cta flex flex-end">
              <saffron-link  class="flex" :to="{name: 'store-productId', params: {productId: product.id}}">
                <icon-halo
                  size="1.5"
                  halo-theme="alt"
                  theme="bg-5"
                  icon="arrow-inline-end"></icon-halo>
              </saffron-link>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import asyncOperations from "@/client/extensions/composition/asyncOperations.js";
import { useStore } from "vuex";
export default {
  components: {},
  layout: {
    component: "default",
    props: {},
  },
  middleware: {},
  setup(props) {
    const { asyncOps, asyncOpsReady, asyncStatus } = asyncOperations(props, useStore());
    return { asyncOps, asyncOpsReady, asyncStatus };
  },
  meta: {
    title: "ag.meta.store.title",
    description: "ag.meta.store.description",
  },
  data() {
    return {
      products: false,
      asyncData: {
        products: {
          target: `ecommerce/product`,
          data: { pagination: { start: 0, limit: 100 } },
          options: {
            dataMutator(res) {
              console.log("products", res);
              return res.items;
            },
          },
        },
      },
    };
  },
  computed: {},
  watch: {},
  mounted() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.product-intro {
  border-radius: var(--border-radius);
  padding: var(--margin-xl) var(--margin-l) var(--margin-m) var(--margin-l);
  background-color: var(--c-lead-1);
  width: 310px;

  @media (max-width: 359px) {
    width: 280px;
  }

  &:nth-child(3n + 2) {
    background-color: var(--c-lead-2);
  }

  &:nth-child(3n + 3) {
    background-color: var(--c-lead);
  }
  .product-image-container {
    width: 100%;
    height: 180px;

    .product-image {
      object-fit: contain;
    }
  }
}
</style>
